import React from "react";
import PromoSlider from "@components/common/widgets/PromoSlider";
import Roaming from "@components/common/widgets/Roaming";
import RoamingIDDService from "@components/roaming/RoamingIDDService";
import Footer from "@components/common/footer/Footer";
import Navigation from "@components/common/Navigation/Navigation";

export default function RoamingApp() {
  return (
    <div className="react-row">
      <Navigation />
      <main>
        <PromoSlider urlAPI="promoslider.roaming" />
        <Roaming urlAPI="roaming" />
        <RoamingIDDService />
      </main>
      <Footer />
    </div>
  );
}
